/* Progressive enhancement: without JS all media remain accessible. */
(() => {
  'use strict';
  if (window.NordlysProductGallery) return;
  const instances = new Map();
  const desktop = window.matchMedia('(min-width: 1025px)');
  const translations = {
    fr: ['Voir plus', 'Voir moins'], en: ['Show more', 'Show less'],
    de: ['Mehr anzeigen', 'Weniger anzeigen'], es: ['Ver más', 'Ver menos'],
    it: ['Mostra di più', 'Mostra di meno'], nl: ['Meer tonen', 'Minder tonen'],
    da: ['Se mere', 'Se mindre'], pl: ['Zobacz więcej', 'Zobacz mniej']
  };
  function init(root) {
    if (instances.has(root)) return;
    const grid = root.querySelector('[data-nl-gallery-grid]');
    const button = root.querySelector('[data-nl-gallery-more]');
    const info = root.querySelector('.t4s-product__info-container');
    const header = document.querySelector('.t4s-section-header');
    const slides = grid ? Array.from(grid.querySelectorAll('[data-main-slide]')) : [];
    let expanded = false, frame = 0, signature = '', disposed = false;
    const visibleSlides = () => slides.filter(item => !item.classList.contains('is--media-hide'));
    function label() {
      if (!button) return;
      // Shopify locale is the fallback; Weglot can update <html lang> in place.
      const lang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
      const labels = translations[lang] || [button.dataset.nlMore, button.dataset.nlLess];
      const text = labels[expanded ? 1 : 0];
      if (button.textContent !== text) button.textContent = text;
      button.setAttribute('aria-expanded', String(expanded));
    }
    function update() {
      frame = 0;
      if (disposed) return;
      const active = desktop.matches;
      const visible = visibleSlides();
      const nextSignature = visible.map(item => item.dataset.mediaId).join(',');
      if (signature && signature !== nextSignature) expanded = false;
      signature = nextSignature;
      slides.forEach(item => item.removeAttribute('data-nl-overflow'));
      // Limit the currently selected variant's gallery, not hidden variant media.
      if (active && button && !expanded) {
        visible.slice(8).forEach(item => item.setAttribute('data-nl-overflow', ''));
      }
      if (button) {
        button.hidden = !active || visible.length <= 8;
        label();
      }
      if (grid) {
        slides.forEach(item => {
          item.style.removeProperty('grid-column');
          item.style.removeProperty('grid-row');
        });
        if (active) {
          const heights = [0, 0];
          visible.filter(item => !item.hasAttribute('data-nl-overflow')).forEach(item => {
            const column = heights[0] <= heights[1] ? 0 : 1;
            const height = Math.ceil(item.getBoundingClientRect().height) + 10;
            item.style.gridColumn = String(column + 1);
            item.style.gridRow = `${heights[column] + 1} / span ${height}`;
            heights[column] += height;
          });
          grid.classList.add('nl-gallery-masonry');
        } else grid.classList.remove('nl-gallery-masonry');
      }
      if (info && active) {
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        // A tall panel scrolls until its lower controls are visible, then sticks.
        const top = Math.min(headerHeight + 16, window.innerHeight - info.offsetHeight - 24);
        const value = `${Math.round(top)}px`;
        if (root.style.getPropertyValue('--nl-info-top') !== value) root.style.setProperty('--nl-info-top', value);
      } else root.style.removeProperty('--nl-info-top');
    }
    function schedule() {
      if (!frame && !disposed) frame = requestAnimationFrame(update);
    }
    function toggle() {
      const focusTarget = visibleSlides()[8];
      expanded = !expanded;
      update();
      if (expanded && focusTarget) {
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus({ preventScroll: true });
        focusTarget.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      } else if (button) button.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }
    function variantChanged(event) {
      update();
      const id = event.currentVariant && event.currentVariant.featured_media && event.currentVariant.featured_media.id;
      const selected = slides.find(item => item.dataset.mediaId === String(id));
      // Kalles scrolls to the selected variant's photo: reveal it first if needed.
      if (desktop.matches && selected && selected.hasAttribute('data-nl-overflow')) {
        expanded = true;
        update();
      }
    }
    const jq = window.jQuery_T4NT;
    const productRow = root.querySelector('[data-product-featured]');
    if (jq && productRow) jq(productRow).on('variant:changed.nlGallery', variantChanged);
    const mutations = new MutationObserver(records => {
      if (records.some(record => {
        if (!slides.includes(record.target)) return false;
        const wasHidden = (record.oldValue || '').split(/\s+/).includes('is--media-hide');
        return wasHidden !== record.target.classList.contains('is--media-hide');
      })) schedule();
    });
    if (grid) mutations.observe(grid, { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    const localeObserver = new MutationObserver(label);
    localeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
    const resizeObserver = new ResizeObserver(schedule);
    if (grid) resizeObserver.observe(grid);
    if (info) resizeObserver.observe(info);
    if (header) resizeObserver.observe(header);
    // Media can change height after a video or 3D viewer is mounted.
    slides.forEach(item => resizeObserver.observe(item));
    if (button) button.addEventListener('click', toggle);
    window.addEventListener('resize', schedule, { passive: true });
    desktop.addEventListener('change', schedule);
    root.addEventListener('load', schedule, true);
    update();
    instances.set(root, () => {
      disposed = true;
      cancelAnimationFrame(frame);
      mutations.disconnect(); resizeObserver.disconnect(); localeObserver.disconnect();
      window.removeEventListener('resize', schedule);
      desktop.removeEventListener('change', schedule);
      root.removeEventListener('load', schedule, true);
      if (button) button.removeEventListener('click', toggle);
      if (jq && productRow) jq(productRow).off('variant:changed.nlGallery', variantChanged);
      instances.delete(root);
    });
  }
  function scan() { document.querySelectorAll('[data-nl-product-gallery]').forEach(init); }
  window.NordlysProductGallery = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) if (event.target.contains(root)) dispose();
  });
})();
